import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	fetchConnectorListFail,
	fetchConnectorListSuccess,
	initConnectorList,
	refreshConnectorList,
	updateIncludePublic,
	bulkDeleteConnectors,
	deleteConnector,
	deleteConnectorFail,
	fetchPublicProjectDetails,
	fetchPublicProjectDetailsSuccess,
} from './connector.actions';
import { ConnectorOriginalSliceState } from './connector.state';

export const connectorOriginalReducer =
	createReducer<ConnectorOriginalSliceState>(
		new ConnectorOriginalSliceState(),
		on(goToProjects, setProject, (state) => state.clear()),
		on(initConnectorList, refreshConnectorList, (state) =>
			state.setLoading(true)
		),
		on(fetchConnectorListFail, (state) => state.setLoading(false)),
		on(fetchConnectorListSuccess, (state, action) =>
			state.setLoading(false).setConnectorList(action.connectorList)
		),
		on(updateIncludePublic, (state, action) =>
			state.setLoading(true).toggleIncludePublicProjects(action.includePublic)
		),
		on(fetchPublicProjectDetails, (state) =>
			state.setIsLoadingPublicProjectDetails(true)
		),
		on(fetchPublicProjectDetailsSuccess, (state, action) =>
			state
				.setIsLoadingPublicProjectDetails(false)
				.setConnectorList(state.list.updateItem(action.connectorId))
		),
		on(deleteConnector, bulkDeleteConnectors, (state) =>
			state.setLoading(true)
		),
		on(deleteConnectorFail, (state) => state.setLoading(false))
	);
